export default {

	getFields(Selector) {
		return {
			userPassword : {required: true, userPassword: true},
			userPasswordConfirm :{required: true, userPasswordConfirm: true}
		}
	},
}export default {

	getFields(Selector) {
		return {
			userPassword : {required: true, userPassword: true},
			userPasswordConfirm :{required: true, userPasswordConfirm: true}
		}
	},
}